//Core
import React from "react"

//Components
import Header from "../components/Header"

import Cards from "../components/Cards"
import Footer from "../components/Footer"
import SEO from "../components/seo"
import Form from "../components/Form"

//Styles
import "../styles/main.scss"

const IndexPage = () => (
  <div>
    <SEO
      title="Максимальний дохід з депозитом “Акційний”!"
      description={`Відкрити у будь-якому відділенні ТАСКОМБАНК депозит “Акційний” у гривні строком до 12 місяців та отримуйте максимальний дохід`}
    />
    <Header />
    <Cards />
    <Form />
    <Footer />
  </div>
)

export default IndexPage
